<template>
    <p> {{ attributes }}</p>
</template>

<script>
export default {
    name: 'BnCaption',

    props: {
        attributes: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>
